import cx from "classnames";
import React from "react";

import * as styles from "./FormattedText.module.css";

const boldStart = "*>";
const boldEnd = "<";
const breakline = "<br/>";

type FormattedTextProps = {
  text: string;
  className?: string;
};

export const FormattedText = (props: FormattedTextProps) => {
  let setOfPositionBoldWords = new Set();
  let arrayOfSublines: string[] = [];
  let textWithBreaklines: string[] = [];

  const traverseAndParseBoldWords = (line: string) => {
    /**
     * Find the start "*>" and the end "<*>" of a bold section, and separate
     * the values into an array
     *
     * If exists "<", this position of the array is a bold string.
     * Finally clean the last char "<"
     */
    arrayOfSublines = line.split(boldStart);
    setOfPositionBoldWords = new Set();
    for (let i = 0; i < arrayOfSublines.length; i++) {
      const subline = arrayOfSublines[i];
      const isBold = subline.includes(boldEnd);
      if (isBold) {
        setOfPositionBoldWords.add(i);
      }
      if (subline.slice(-1) === boldEnd) {
        arrayOfSublines[i] = ` ${subline.slice(0, -1)}`;
      } else {
        arrayOfSublines[i] = ` ${subline}`;
      }
    }
  };

  const traverseAndParseBreakLines = () => {
    // Split the description into an array by searching the breakline sintax.
    // Each position is a phrase.
    if (props.text) {
      textWithBreaklines = props.text.split(breakline);
    }
  };

  traverseAndParseBreakLines();

  return (
    <>
      {textWithBreaklines.map(line => {
        traverseAndParseBoldWords(line);
        return arrayOfSublines.map((subline, index) => (
          <span key={index} className={cx(styles.text, props.className)}>
            {setOfPositionBoldWords.has(index) ? <b>{subline}</b> : subline}
            {index === arrayOfSublines.length - 1 && <br />}
          </span>
        ));
      })}
    </>
  );
};
